<template>
      <v-dialog v-model="dialog" persistent max-width="500px">

      <v-card>
        <v-toolbar dark color="primary elevation-1" dense>
          <v-btn icon @click.native="close" dark>
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>New task</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark text @click.native="save" :disabled="!valid">Save</v-btn>
          </v-toolbar-items>

        </v-toolbar>
        <v-card-text>
          <v-form v-model="valid" ref="form" lazy-validation>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field v-model="form.title" label="Title" :rules="itemRules" required></v-text-field>
              </v-flex>
              <v-flex xs12 sm7>
                <v-menu
                  :close-on-content-click="false"
                  v-model="menu_dates"
                  transition="scale-transition"
                  offset-y
                  :nudge-right="40"
                  min-width="290px"
                >

                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-on="on"
                      label="Date"
                      v-model="dateFormatted"
                      prepend-icon="event"
                      readonly
                      :rules="itemRules"
                      required
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="form.date" no-title scrollable
                  @input="dateFormatted = formatDate($event)"
                  @change="menu_dates=false"
                  >
                  </v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs12 sm5>
                <v-menu
                  :close-on-content-click="false"
                  v-model="menu_time"
                  transition="scale-transition"
                  offset-y
                  :nudge-right="40"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-on="on"
                      label="Time"
                      v-model="form.time"
                      prepend-icon="access_time"
                      readonly
                    ></v-text-field>
                  </template>
                  <v-time-picker v-model="form.time"
                  color="primary"
                  format="24hr"
                  autosave
                  @change="menu_time=false"
                  ></v-time-picker>
                </v-menu>
              </v-flex>
              <v-flex xs12>
                <v-textarea
                  label="Comment"
                  v-model="form.comment"
                  multi-line
                  outlined
                ></v-textarea>
              </v-flex>
              <v-flex>

              <v-select
                label="User"
                v-model="form.user"
                :items="users"
                item-text="firstname"
                item-value="id"
                chips
                multiple
              ></v-select>

              </v-flex>
            </v-layout>
        </v-container>
        <small>*indicates required field</small>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
  import moment from 'moment';
  import recur from 'moment-recur';
  import todoMixin from '@/components/todo/todoMixin'

  export default {
    mixins: [todoMixin],
    data () {
      return {
        date: null,
        dates: [],
        menu_dates: false
      }
    },
    methods: {
      removeDate (item) {
        this.form.dates.splice(this.form.dates.indexOf(item), 1)
        this.form.dates = [...this.form.dates];
      },
      reset () {
        this.dateFormatted = null;
        this.form.time = moment().format('HH:mm');
        this.form.date = moment().format('YYYY-MM-DD');
        this.form.comment = null;
        this.form.user = null;
        if (this.$refs.form) {
           this.$refs.form.resetValidation();
        }
      },
      prefill (d) {
        this.reset();
        this.dateFormatted = this.formatDate(d.date);
        console.log('frefill: ', d);
      },
      init (v) {
        if (v) {

          this.prefill(this.form);
          // this.test('01/01/2014', '01/30/2014');
        }
      },
      test (start, end, every) {
        var recurrence = moment().recur(start, end).every(every).days();
        // Outputs: ["01/01/2014", "01/03/2014", "01/05/2014", "01/07/2014"]
        if (recur) {
          console.log(recurrence.all('L'));
        }
        return recurrence.all('L');
      }
    },
    watch: {
      dialog (value) {
        this.init(value);
      }
    }
  }
</script>

